<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-05 11:56:42
 * @LastEditTime: 2022-12-12 15:56:17
 * @LastEditors: Smart Chow
 -->
<template>
  <div
    v-if="showDom"
    class="loginPage"
    :style="
      loginBg
        ? `background:url(${loginBg}) no-repeat;background-size:100% 100%;`
        : ''
    "
  >
    <!--登陆logo-->
    <!-- <div class="logoCotainer">
      <img
        v-if="!loginBg"
        :src="require('@/common/assets/login/logo-english.png')"
        alt=""
      />
    </div> -->
    <!--背景图片-->
    <div class="nurse-login-bg">
      <img
        v-if="!loginBg"
        class="img"
        :src="require('@/common/assets/login/nurse-login.png')"
        alt=""
      />
      <img
        v-if="!loginBg"
        class="img-title"
        :src="require('@/common/assets/images/logo.svg')"
        alt=""
      />
    </div>
    <!--登陆框-->
    <div class="nurse-login-main">
      <div class="login-wrap">
        <div class="login-wrap__header">
          <img :src="require('@/common/assets/login/logo-card.png')" alt="" />
          <div v-if="loginBg">卫宁护理管理</div>
        </div>
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          label-width="32px"
        >
          <el-form-item label="账号" prop="UserId" class="mt-10">
            <el-input
              v-model.trim="loginForm.UserId"
              autofocus
              maxlength="10"
              placeholder="请输入账号"
              @keyup.enter.native="nextInput()"
            />
          </el-form-item>
          <el-form-item label="密码" prop="Password" class="pt-15">
            <el-input
              ref="passwordInput"
              v-model.trim="loginForm.Password"
              :type="hidePassword ? 'password' : 'input'"
              placeholder="请输入密码"
              @focus="handlePasswordFocus"
              @keyup.enter.native="submitForm"
            >
              <span v-if="loginForm.password" slot="suffix">
                <img :src="iconClear" alt="" @click="clearInput()" />
                <img
                  :src="hidePassword ? iconHide : iconShow"
                  class="d2-ml-5"
                  alt=""
                  @click="toggleHide()"
                />
              </span>
            </el-input>
          </el-form-item>
        </el-form>
        <button
          class="login-wrap-submit"
          @click="submitForm"
          @keyup.enter="submitForm"
        >
          登录
        </button>
      </div>
    </div>
    <div class="version">
      Copyright © 卫宁健康科技集团股份有限公司 软件版本：{{ versionInfo }}
    </div>
  </div>
</template>
<script>
import store from '@/frameworks/store'
// import { isvalidUsername } from "@/utils/validate";
const getFirstAccessMenu = function (menuDtos) {
  for (let i = 0; i < menuDtos.length; i++) {
    if (menuDtos[i].children && menuDtos[i].children.length > 0) {
      return getFirstAccessMenu(menuDtos[i].children)
    } else {
      return menuDtos[i]
    }
  }
}

import iconClear from '@/common/assets/login/icon_clear.png'
import iconHide from '@/common/assets/login/icon_hide.png'
import iconShow from '@/common/assets/login/icon_show.png'
import AES from '@/common/utils/aes.js'
export default {
  name: 'Login',
  data() {
    var checkLoginName = (rule, value, callback) => {
      if (this.errType === '1') {
        callback(new Error('账号不存在'))
      } else {
        callback()
      }
    }
    var checkPassword = (rule, value, callback) => {
      if (this.errPassword) {
        callback(new Error('用户名或密码错误，请重新输入'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        UserId: '',
        Password: ''
      },
      //
      loginRules: {
        UserId: [{ required: true, trigger: 'blur', message: '账号不能为空' }]
        // ,
        // Password: [
        //   { required: false, trigger: 'blur', message: '密码不能为空' }
        // ]
      },
      iconClear: iconClear,
      iconShow: iconShow,
      iconHide: iconHide,
      rules: {
        loginName: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { validator: checkLoginName, trigger: 'blur' }
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' }
        ]
      },
      errPassword: false, // 密码是否错误
      errType: '', // 错误类别，1 账号不存在，4暂无分配的角色，请联系管理员
      hidePassword: true, // 是否隐藏密码
      loginBg: globalConfig.LOGIN_BG || '',
      versionInfo: '',
      showDom: false
    }
  },
  beforeCreate() {
    // 清除上次访问时的 本地缓存
    window.localStorage.removeItem('vuex')
    this.showDom = !this.$route.query.skipPwd
  },
  created() {
    this.getVersion()
    if (this.$route.query.HospitalCode) {
      store.commit('SET_HOSPITAL_CODE', this.$route.query.HospitalCode)
    } else {
      store.commit('SET_HOSPITAL_CODE', null)
    }
    if (this.$route.query.skipPwd || this.$route.query.pwd) {
      for (var key in this.$route.query) {
        var lowerkey = key.toLowerCase()
        this.$route.query[lowerkey] = this.$route.query[key]
      }
      store
        .dispatch('GetLoginUserInfo', {
          skipPwd: this.$route.query.skipPwd,
          UserId: this.$route.query.userid || this.$route.query.uid,
          Password: this.$route.query.skipPwd ? '' : this.$route.query.pwd,
          From: 'nqcs'
        })
        .then((res) => {
          if (res.success) {
            if (res.menus.length === 0) {
              this.$router.push('*')
              this.$Confirm(
                '您尚无任何菜单权限，请联系管理员，对您所在的角色组设置菜单权限',
                '信息',
                {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'error'
                }
              )
              return
            }
            const firstMenuDto = getFirstAccessMenu(res.menus || [])
            if (firstMenuDto) {
              this.$router.push(firstMenuDto.fullPath)
            } else {
              this.$router.push('/')
            }
          }
        })
    } else {
      this.showDom = true
    }
  },
  methods: {
    nextInput() {
      this.$refs.passwordInput.focus()
    },
    handlePasswordFocus() {
      if (this.errPassword) {
        this.errPassword = false
        this.$refs.loginForm.validateField('password')
      }
    },
    clearInput() {
      this.loginForm.password = ''
    },
    toggleHide() {
      this.hidePassword = !this.hidePassword
    },
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          var encrypts = AES.encrypt(this.loginForm.Password)
          // var dess = AES.decrypt(encrypts)
          // console.log(dess)
          store
            .dispatch('GetLoginUserInfo', {
              UserId: this.loginForm.UserId,
              password: encrypts,
              From: 'nqcs'
            })
            .then((res) => {
              if (res.success) {
                store.dispatch('setFlag', true)
                if (res.menus.length === 0) {
                  this.$router.push('*')
                  this.$Confirm(
                    '您尚无任何菜单权限，请联系管理员，对您所在的角色组设置菜单权限',
                    '信息',
                    {
                      confirmButtonText: '确定',
                      showCancelButton: false,
                      type: 'error'
                    }
                  )
                  return
                }
                // this.$router.push('/GZT/GZTList')
                // 获得第一个菜单项，直接打开.
                const firstMenuDto = getFirstAccessMenu(res.menus || [])
                const gotoPage = firstMenuDto ? firstMenuDto.fullPath : '/'
                store.dispatch('getSystemParam').then((res) => {
                  this.$router.push(gotoPage)
                })
              }
            })
        } else {
          return false
        }
      })
    },
    getVersion() {
      this.$requestApi('GetSystemVersion', {})
        .then((res) => {
          if (res.success) {
            this.versionInfo = res.data
          }
        })
        .catch((err) => {})
    }
  }
}
</script>
<style lang="scss" scoped>
//配置主题色文件
$mainColor: #719dfc;
$secondaryColor: #5696ff;
$thirdlyColor: #306ae8;
$fourthColor: #3370f3;
.notShowDom {
  width: 100%;
  height: 100%;
  background-color: red;
}
.loginPage {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: $fourthColor;
  background: -webkit-linear-gradient(
    $thirdlyColor,
    $fourthColor
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    $thirdlyColor,
    $fourthColor
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    $thirdlyColor,
    $fourthColor
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient($thirdlyColor, $fourthColor); /* 标准的语法 */
  position: relative;
  min-width: 1000px;
  min-height: 500px;
  overflow: auto;
  .logoCotainer {
    position: absolute;
    left: 40px;
    top: 45px;
  }
  .nurse-login-bg {
    float: left;
    width: 60%;
    height: 100%;
    text-align: center;
    .img {
      position: fixed;
      top: 20%;
      left: 15%;
      // max-width: 70%;
      // max-height: 80%;
      // vertical-align: middle;
    }
    .img-title {
      position: fixed;
      top: 50px;
      left: 50px;
    }
    &:after {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }
  }
  .nurse-login-main {
    float: left;
    width: 40%;
    height: 100%;
    position: relative;
    .login-wrap {
      width: 330px;
      height: 300px;
      background-color: #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      border-radius: 4px;
      transform: translate(-50%, -50%);
      .login-wrap__header {
        // line-height:90px;
        text-align: center;
        // height: 90px;
        margin-bottom: 10px;
      }
      ::v-deep .el-form {
        padding: 0 30px;
        .el-form-item {
          border-bottom: 1px solid #d9dbe7;
          .el-form-item__label {
            font-size: 16px;
            color: $fourthColor;
            padding: 0;
            &::before {
              content: '';
              margin: 0;
            }
          }
          .el-input__inner {
            font-size: 15px;
            border: none;
          }
          &.is-error {
            .el-form-item__label,
            .el-input__inner {
              color: #fa0505;
            }
            .el-form-item__error {
              left: -32px;
            }
          }
        }
      }
      .login-wrap-submit {
        position: absolute;
        bottom: 50px;
        left: 30px;
        width: 270px;
        border-radius: 2px;
        height: 40px;
        line-height: 40px;
        background: $fourthColor;
        font-size: 16px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        &:hover {
          background: $fourthColor;
          box-shadow: 0 2px 4px 0 $mainColor;
        }
      }
    }
  }
  .version {
    font-family: '微软雅黑', '宋体', 'Arial Narrow', Helvetica, sans-serif;
    font-size: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: center;
    color: #eee;
  }
}
</style>
